import Navigation from "./Drawer/Navigation";
const Drawer = ({ isVisible, onHandleDrawer, isDown, isSticky }) => {
  return (
    <div className="hidden xsl:block">
      <Navigation isVisible={isVisible} onHandleDrawer={onHandleDrawer} />
    </div>
  );
};

export default Drawer;
